<template>
  <div class="limiter__account">
      <div class="container__account">
          <div v-for="application in applications" :key="application.id_application" class="wrap__account">
              <div class="account__form validate-form">
                  <div class="account__main-wrapper">
                    <a class="account__icon" target="_blank" v-bind:style="{ 'background-image': 'url(https://www.google.com/s2/favicons?sz=128&domain_url=' + application.url + ')' }" v-bind:href="'https://' + application.url" :id="application.id_application"></a>
                    <div class="input account__login" v-on:click="copy(application.login)">{{application.login}}</div>
                    <div class="input account__pass" v-on:click="copy(application.password)"></div>
                    <div class="account__more" v-on:click="more($event)"></div>
                  </div>
              </div>
          </div>
          <div class="container__account__search-bar">
            <div class="container__account__search-bar__svg"></div>
            <input class="container__account__search-bar__input" placeholder="Search ..." v-on:keyup="search()">
            <div class="container__account__add" @click="add()"></div>
          </div>
      </div>
      <div v-if="application_selected" class="container__application">
        <div class="container-back" style="left:calc(100vw + 10px); top: 20px; height: 20px;">
          <div class="container-back-svg"></div>
          <a class="container-back-span" style="color: dimgrey;" @click="less()">Back to all</a>
        </div>
        <div class="container__application__header">
          <a class="account__icon" target="_blank" v-bind:style="{ 'background-image': 'url(https://www.google.com/s2/favicons?sz=128&domain_url=' + application_selected.url + ')' }" v-bind:href="'https://' + application_selected.url"></a>
          <input :value="application_selected.url" @input="update('url', $event)">
          <p v-if="application_selected.url == ''">- url -</p>
        </div>
        <div class="container__application__messages">{{ message }}</div>
        <div class="container__application__content">
          <span>Login</span>
          <input class="input account__login" type="text" name="pass" @input="update('login', $event)" :value="application_selected.login">
          <span>Password</span>
          <div class="account__password">
            <input class="input" type="password" name="pass" @input="update('password', $event)" :value="application_selected.password">
            <span class="account__btn-show-pass" v-on:click="changeState($event)">
                <i class="zmdi zmdi-unhide"></i>
            </span>
          </div>
          <span>Description</span>
          <textarea class="account-wrap__description" @input="update('description', $event)" :value="application_selected.description"></textarea>
          <div class="account-wrap__options">
            <div class="account-wrap__options-password">
              <div class="account-wrap__options-password__span" @click="generatePassword()">Generate password</div>
              <div class="account-wrap__options-password__options">
                <input class="account-wrap__options-password__options-len" value="20">
                <label type="checkbox" class="account-wrap__options-password__options-num">
                  <p>num</p>
                  <input type="checkbox" checked="checked">
                  <span class="checkmark"></span>
                </label>
                <label type="checkbox" class="account-wrap__options-password__options-pun">
                  <p>pun</p>
                  <input type="checkbox" checked="checked">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="account-wrap__options-delete" @click="deleteApplication()" >Delete account</div>
            <div class="account-wrap__options-save" @click="updateApplication()" v-if="updated && application_selected.id_application != ''">Save changes</div>
            <div class="account-wrap__options-save" @click="addApplication()" v-if="application_selected.id_application == ''">Add account</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script type="text/javascript" src="../assets/js/login.js"></script>

<script>
import ApplicationService from '@/services/ApplicationService.js'

export default {
  data () {
    return {
      applications: [],
      application_selected: null,
      updated: false,
      timeout: null,
      message: '',
      msg: ''
    }
  },
  async created () {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login')
    }
    this.getApplications()
  },
  methods: {
    async getApplications () {
      try {
        this.applications = []
        const credentials = { user: this.$store.getters.getUser }
        let applicationsEncrypted = await ApplicationService.getApplications(credentials)
        for(let application of applicationsEncrypted) {
          this.applications.push(ApplicationService.decryptContent(this.$store.getters.getKey, application))
        }
      } catch (error) {
        this.msg = error
      }
    },
    copy(content) {
      const el = document.createElement('textarea');
      el.value = content;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      document.execCommand(content);
    },
    changeState(event) {
      let span = $($(event.target).parent()[0])
      if($(span).prev('input').attr('type') != 'text')
      {
          $(span).prev('input').attr('type','text');
          $(span).find('i').removeClass('zmdi-unhide');
          $(span).find('i').addClass('zmdi-hide');
      }
      else
      {
          $(span).prev('input').attr('type','password');
          $(span).find('i').addClass('zmdi-unhide');
          $(span).find('i').removeClass('zmdi-hide');
      }
    },
    more(event) {
      let application_wrapper = $(event.target).parent().parent()
      let container = document.querySelector('.limiter__account')
      container.style.transform = 'translateX(-100vw)'
      this.application_selected = this.applications.find(o => o.id_application == $($(event.target).parent()[0]).find('a')[0].id )
      // this.selected_url = new URL(this.application_selected.url).hostname
      // this.selected_url = this.selected_url.substring(this.selected_url.lastIndexOf(".", this.selected_url.lastIndexOf(".") - 1) + 1)
    },
    less() {
      let container = document.querySelector('.limiter__account')
      container.style.transform = 'translateX(0)'
    },
    openLink(link) {
      window.open(link);
    },
    search() {
      let input = document.querySelector(".container__account__search-bar__input");
      let filter = input.value.toUpperCase();
      let accounts = document.querySelectorAll('.wrap__account');

      for (let i = 0; i < accounts.length; i++) {
          let a = accounts[i].getElementsByTagName("a")[0];
          let login = accounts[i].querySelector(".account__login");
          if (a.href.toUpperCase().indexOf(filter) > -1 || login.value.toUpperCase().indexOf(filter) > -1) {
              accounts[i].style.display = "";
          } else {
              accounts[i].style.display = "none";
          }
      }
    },
    async updateApplication() {
      if( this.updated ) {
        const credentials = { application: ApplicationService.encryptContent(this.$store.getters.getKey, this.application_selected) }
        let res = await ApplicationService.updateApplication(credentials)

        if( res.changedRows > 0) {
          this.message = "Your account has been updated !";
        } else {
          this.message = "Nothing has changed !";
        }
        this.timeout = setTimeout(() => {
          this.message = ''
        }, 3000)
      }
    },
    update: function(prop, event) {
      this.application_selected[prop] = event.target.value;
      this.updated = true;
    },
    generatePassword: function() {

      var len, numericB, punctuationB = false;

      len = document.querySelector(".account-wrap__options-password__options-len").value;
      numericB = document.querySelector(".account-wrap__options-password__options-num").querySelector('input').checked;
      punctuationB = document.querySelector(".account-wrap__options-password__options-pun").querySelector('input').checked;

      var length = (len)?(len):(10);
      var string = "abcdefghijklmnopqrstuvwxyz";
      var numeric = '0123456789';
      var punctuation = '!@#$%^&*()_+~`|}{[]\:;?><,./-=';
      var password = "";
      var character = "";
      var crunch = true;
      while( password.length<length ) {
          let entity1 = Math.ceil(string.length * Math.random()*Math.random());
          let entity2 = Math.ceil(numeric.length * Math.random()*Math.random());
          let entity3 = Math.ceil(punctuation.length * Math.random()*Math.random());
          let hold = string.charAt( entity1 );
          hold = (password.length%2==0)?(hold.toUpperCase()):(hold);
          character += hold;
          if(numericB)
            character += numeric.charAt( entity2 );
          if(punctuationB)
            character += punctuation.charAt( entity3 );
          password = character;
      }
      password=password.split('').sort(function(){return 0.5-Math.random()}).join('');
      this.application_selected.password = password.substr(0,len);
      this.updated = true;
    },
    add: function() {
      let container = document.querySelector('.limiter__account')
      container.style.transform = 'translateX(-100vw)'
      this.application_selected = {
        id_application: '',
        url: '',
        login: '',
        password: '',
        description: '',
        id_user: this.$store.getters.getUser.id_user
      }
    },
    addApplication: async function() {
      let application = ApplicationService.encryptContent(this.$store.getters.getKey, this.application_selected)
      const credentials = { application: application }
      let res = await ApplicationService.addApplication(credentials);
      if( res.insertId ) {
        this.message = "Your account has been successfully created !";
        this.application_selected.id_application = res.insertId;
        this.getApplications()
      } else {
        this.message = "All required fields must been filled";
      }
      this.timeout = setTimeout(() => {
        this.message = ''
      }, 3)
    },
    deleteApplication: async function() {
      const credentials = { id_application: this.application_selected.id_application }
      let res = await ApplicationService.deleteApplication(credentials)
      if(res.affectedRows > 0) {
        this.getApplications()
        this.less()
      }
    }
  }
}
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');

.account-wrap__options-password {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .account-wrap__options-password__span {
    width: 70%;
  }

  .account-wrap__options-password__options {
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    > * {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 1px solid #3ad29f !important;
      background-color: #efeeee;
      text-align: center;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .account-wrap__options-password__options-len {

    }
    .account-wrap__options-password__options-num, .account-wrap__options-password__options-pun {
      position: relative;
      display: flex;
      flex-direction: column;

      p {
        margin-top: 30px;
        font-size: 10px;
      }

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
      }

      :hover input ~ .checkmark {
        background-color: #ccc;
      }

      input:checked ~ .checkmark {
      }

      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      input:checked ~ .checkmark:after {
        display: block;
      }

      .checkmark:after {
        left: 10px;
        top: 6px;
        width: 5px;
        height: 10px;
        border: solid dimgrey;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }
}

.container__account__search-bar {
  margin: 5vh 0;
  width: 70vw;
  height: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 1em;
  border: 2px solid dimgrey;
  border-radius: 10px;

  .container__account__search-bar__svg {
    background-size: 20px;
    background-image: url('../assets/search.svg');
    background-repeat: no-repeat;
    height: 20px;
    width: 20px;
  }

  .container__account__search-bar__input {
    margin-left: 2em;
    width: calc(100% - 50px);
  }

  .container__account__add {
    background-size: 20px;
    background-image: url(../assets/plus.svg);
    background-repeat: no-repeat;
    height: 20px;
    width: 20px;
  }
}

.container__application__header {
  width: 100vw;
  height: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;

  input {
    color: #efeeee;
    text-align: center;
    width: inherit;
  }

  p {
    color: #efeeee;
  }
}
.container__application__messages {
  width: 100vw;
  height: 5%;
  color: #efeeee;
  text-align: center;
}
.container__application__content {
  width: 100vw;
  height: 71%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;
  border-top: 1px solid #4caf50;
  border-radius: 4%/1%;
  background-color: #efeeee;

  > * {
    margin: 0.25em 0;
  }

  input {
    padding:0 !important;
  }
}

.container__application {
  width: 100vw;
  height: 90vh;
  padding-top: 50px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(240)'%3E%3Cstop offset='0' stop-color='%234caf50'/%3E%3Cstop offset='1' stop-color='%234FE'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-size: cover;
}

input:focus
{
    border-color: transparent !important;
}
input:-internal-autofill-selected {
    background-color: #ddd !important;
}

input:focus::-webkit-input-placeholder
{
    color: transparent !important;
}
input::-webkit-input-placeholder
{
    color: #adadad;
}
.limiter__account
{
  width: 200vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  transition: transform 0.5s ease;
}
.container__account
{
    width: 100vw;
    min-height: calc(100vh - 100px);
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: center;
    padding: 15px;
}
.wrap__account
{
    width: 80vw;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 3px 3px #efeeee,
                6px 6px 8px 4px rgba(136,136,136,0.7),
                -6px -6px 8px 4px rgba(244,244,244,0.9);
    margin: 1em 0;
}

.account__form
{
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
}
.account__form-title
{
    display: block;
    font-family: 'Poppins';
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 1.2;
    text-align: center;
    padding-bottom: 60px;
}

.wrap-input
{
    width: 100%;
    position: relative;
    border-bottom: 2px solid #adadad;
    margin-bottom: 38px;
}
.input
{
    font-family: 'Poppins';
    font-size: 15px;
    color: #4caf50;
    line-height: 1.2;
    display: block;
    width: 94%;
    height: 45px;
    background: transparent;
    padding: 0 5px;
}
.focus-input
{
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    pointer-events: none;
}
.focus-input:before
{
    content: "";
    position: absolute;
    display: block;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: #4caf50;
    transition: all 0.4s;

}

.focus-input:after
{
    font-family: 'Poppins';
    font-size: 15px;
    color:#999999;
    line-height: 1.2;
    content: attr(data-placeholder);
    display: block;
    width: 100%;
    position:absolute;
    top: 16px;
    left: 0px;
    padding-left: 5px;
    transition: all 0.4s;
    -webkit-transition: all 0.4s;
}
.input:focus + .focus-input:after
{
    top: -15px;
}
.input:focus + .focus-input:before
{
    width: 100%;
}

.has-val.input + .focus-input::after
{
    top: -15px;
}
.has-val.input:focus + .focus-input:before
{
    width: 100%;
}

.account__btn-show-pass
{
    font-size: 15px;
    color:#999999;
    display: -webkit-flex;
    display: -webkit-box;
    display: flex;
    align-items: center;
    padding-right: 5px;
    cursor: pointer;
    transition: all 0.4s;
}

.btn-show-pass:hover
{
    color:#4caf50;
}

.btn-show-pass:active
{
    color:#4caf50;
}
button
{
    outline: none !important;
    border:none;
    background: transparent;
}
.txt1
{
    font-family: 'Poppins';
    font-size: 13px;
    color: #666666;
    line-height: 1.5;
    text-align: center;
}
.warning {
  color: #ca2a2a;
}
.txt2
{
    font-family: 'Poppins';
    font-size: 13px;
    color: #333333;
    line-height: 1.5;
    text-decoration: none;
    transition: all 0.4s;
}
.txt2:hover
{
    text-decoration: underline;
}

.container-login-form-btn
{
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 20px;
}
.wrap-login-form-btn
{
    width:100%;
    display:block;
    position: relative;
    z-index: 1;
    border-radius: 25px;
    overflow: hidden;
    margin: 0 auto;
    box-shadow: 0 0 3px 3px #efeeee,
                4px 4px 6px 2px rgba(136,136,136,0.7),
                -4px -4px 6px 2px rgba(244,244,244,0.7);

}
.login-form-btn
{
    font-family: 'Poppins';
    font-size: 15px;
    color: #4caf50;
    line-height: 1.2;
    font-weight: bold;
    text-transform: uppercase;
    display: -webkit-flex;
    display: -webkit-box;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 1px;
    padding:0 20px;
    height: 50px;
    width:100%;
    cursor: pointer;
}

.login-form-btn:hover
{
    background: #4caf50;
    color:#ddd;
}
.login-form-btn:active
{
    background: rgb(255,145,19);
    color:#ddd;
}
.text-center
{
    text-align: center;
    padding-top: 70px;
}
@media screen and (max-height: 700px) {
  .text-center
  {
    padding-top: 20px;
  }
}

.validate-input
{
    position: relative;
}

.alert-validate:before
{
    content: attr(data-validate);
    position: absolute;
    max-width:70%;
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid #c80000;
    padding: 4px 25px 4px 10px;
    top: 50%;
    transform: translateY(-50%);
    right:0px;
    pointer-events: none;
    font-family: 'Poppins';
    color: #c80000;
    font-size: 13px;
    line-height: 1.4;
    text-align: left;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.4s;

}

.alert-validate:after
{
    content: "\f1f8";
    font-family:material-design-iconic-font;
    font-size: 21px;
    color: #c80000;
    position:absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
}

.alert-validate:hover:before
{
    visibility: visible;
    opacity: 1;
}

.account__main-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.account__secondary-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: none;
  transition: opacity 0.5s ease;
  opacity: 0;
  margin-top: 2vh;
}

.extended {

}

.account__icon, .account__more {
  background-size: 32px;
  background-position: center;
  background-repeat: no-repeat;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  padding: 33px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.account__more {
  background-size: 16px;
  background-image: url('../assets/expand.svg');
  transform: rotateZ(-90deg);
  padding: 0px;
}

.account__more-extended {
  transform: rotateZ(90deg);
}

.account-wrap__options {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.account-wrap__options > div {
  height: auto;
  width: 100%;
  margin: 5px 0;
  cursor: pointer;
  background-size: 32px;
  background-position: center;
  background-repeat: no-repeat;
}

.account-wrap__options-password {
}

.account-wrap__options-delete {
}

.account-wrap__options-save {
}

.account-wrap__description {
  height: 125px;
  width: calc(100% - 20px);
  max-width: calc(100% - 20px);
  border: 1px solid dimgrey;
  border-radius: 10px;
  padding: 0.5em;
  outline: none !important;
}

.account__login {
  width: auto;
  height: 32px;
  background: #efeeee;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  line-height: 32px;
}

.account__pass {
  width: 32px;
  height: 32px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px;
  background-image: url('../assets/key.svg');
}

.account__password {
  width: calc(100% - 20px);
  height: 32px;
  background: #efeeee;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  input {
    width: auto;
  }
}

.account__password > * {
  height: 32px;
}

.zmdi {
  height: 100%;
  width: 32px;
  background-position: center;
  background-repeat: no-repeat;
}

.zmdi-hide {
  background-size: 16px;
  background-image: url('../assets/hide.svg');
}

.zmdi-unhide {
  background-size: 18px;
  background-image: url('../assets/eye.svg');
}

/*--Responsive-----*/

@media (max-width: 576px)
{
    .wrap-login
    {
        padding:50px 15px 33px 15px;
    }
}

@media (max-width: 992px){
.alert-validate:hover:before
{
    visibility: visible;
    opacity: 1;

}

}

</style>
